/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Userbanner from '../../../../components/elements/Userbanner';
import PdfViewerModal from '../../../../components/elements/PdfViewerModal';
import ImageViewModal from '../../../../components/elements/ImageViewModal';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import './serviceDead.scss';
import { defaultImage } from '../../../../constants';

const CreateServiceForDead = () => {
  const[projectTypeIdInt,setProjectTypeIdInt] = useState(null)
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [getepuserdata, setGetepuserdata] = useState([]);
  const [sDProjectAPIData, setSDProjectAPIData] = useState([]);
  const [relationAPIData, setRelationAPIData] = useState([]);
  const [selectProjectType, setSelectProjectType] = useState('00000000-0000-0000-0000-000000000000');
  const [selectProjectID, setSelectProjectID] = useState(0);
  const [selectProjectCostFrom, setSelectProjectCostFrom] = useState(0);
  const [selectProjectCostTo, setSelectProjectCostTo] = useState(0);
  const [inputEP_IDFile, setinputEP_IDFile] = useState('');
  const [inputDeadCertificate, setInputDeadCertificate] = useState('');
  const [inputApprovalLetter, setInputApprovalLetter] = useState('');
  const [deadName, setDeadName] = useState('');
  const [projectName, setProjectName] = useState('');
  const [gridModalOpenDonor, setGridModalOpenDonor] = useState(false);
  const [gridModalOpenDead, setGridModalOpenDead] = useState(false);
  const [gridModalOpenAppLetter, setGridModalOpenAppLetter] = useState(false);
  const [EP_IDBase64URL, setEP_IDBase64URL] = useState('');
  const [EPDeadCertificateBase64URL, setEPDeadCertificateBase64URL] = useState('');
  const [EPApprovalLetterBase64URL, setEPApprovalLetterBase64URL] = useState('');
  const [allowedFileExtensions, setAllowedFileExtensions] = useState(['png', 'jpg', 'jpeg', 'pdf']);
  const [eP_ID, setEP_ID] = useState('');
  const [eP_DeadCertificate, setEP_DeadCertificate] = useState('');
  const [eP_ApprovalLetter, setEP_ApprovalLetter] = useState('');
  const [countryID, setCountryID] = useState('00000000-0000-0000-0000-000000000000');
  const [relativeID, setRelativeID] = useState(0);
  const [countryAPIData, setCountryAPIData] = useState('');
  const [selecttotalcost, setSelecttotalcost] = useState('');
  const [ep_IDCheck, setEP_IDcheck] = useState('');
  const [deadCertificateCheck, setEP_DeadCertificatecheck] = useState('');
  const [approvalLetterCheck, setEP_ApprovalLettercheck] = useState('');
  const [inputEP_IDFileSize, setInputEP_IDFileSize] = useState('');
  const [inputDeadCertificateFileSize, setInputDeadCertificateFileSize] = useState('');
  const [inputEP_ApprovalLetterFileSize, setInputEP_ApprovalLetterFileSize] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [epUserID, setEpUserID] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const EP_IDInputRef = useRef();
  const EP_DeadCertificateInputRef = useRef();
  const EP_ApprovalLetterInputRef = useRef();
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };

  const getData = () => {
    getAsync('APIClient/ProjectTypesSHJC')
      .then((response) => {
        const result = response?.data;
        setApiData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getEpUserData = async () => {
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID })
      .then((response) => {
        const result = response?.data[0];
        setGetepuserdata(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID != null) {
      isLogin();
      getEpUserData();
      getData();
      getCountries();
      getrelativeIDData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const getCountries = async () => {
    await getAsync('APIClient/CountryListSHJC')
      .then((response) => {
        const result = response?.data;
        setCountryAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const validateSubmit = () => {
    let result = true;

    if (epUserID === '' || epUserID === null) {
      result = false;
      toast.warning(t('Please Enter epUserID'));
    }
    if (relativeID === '' || relativeID === null) {
      result = false;
      toast.warning(t('Please Enter relativeID'));
    }
    if (deadName === '' || deadName === null) {
      result = false;
      toast.warning(t('Please Enter deadName'));
    }
    if (projectName === '' || projectName === null) {
      result = false;
      toast.warning(t('Please Enter projectName'));
    }
    // if (getepuserdata.mobile === '' || getepuserdata.mobile === null) {
    //   result = false;
    //   toast.warning('Please Enter applicantMobile');
    // }
    if (getepuserdata.fullName === '' || getepuserdata.fullName === null) {
      result = false;
      toast.warning(t('Please Enter applicantName'));
    }
    return result;
  };

  const validateSearch = () => {
    let result = true;
    let errorMessage = '';
    if (+selectProjectCostFrom > 0 && +selectProjectCostTo > 0) {
      if (+selectProjectCostFrom > +selectProjectCostTo) {
        result = false;
        errorMessage += t('Cost From should be less then Cost To');
      }
    }
    // else if (+selectProjectCostFrom > +selectProjectCostTo) {
    //   console.log("i am in if")
    //   result = false;
    //   errorMessage += 'Your from cost must be less then ';
    // }

    // if (selectProjectType === '' || selectProjectType === null) {
    //   result = false;
    //   errorMessage += 'Please select Project Type';
    // }
    // if (selectProjectFeature === '' || selectProjectFeature === null) {
    //   result = false;
    //   errorMessage += ' Please select Project Feature\n';
    // }

    // pending condition start
    // if (countryID === '' || countryID === null) {
    //   result = false;
    //   errorMessage += ' Please Select country\n';
    // }
    // end

    // if (
    //   selectProjectCostFrom === '' ||
    //   selectProjectCostFrom === null ||
    //   selectProjectCostTo === '' ||
    //   selectProjectCostTo === null
    // ) {
    //   result = false;
    //   errorMessage += ' Please Enter Project Cost Range\n';
    // }

    if (!result) {
      toast.warning(errorMessage);
    }

    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateSubmit()) {
      try {
        let data = {
          projectID: selectProjectID,
          epUserID: epUserID,
          RelativeID: relativeID,
          deadName,
          projectNotes: '',
          ActiveID: 1,
          selectProjectType,
          projectFeature: '',
          SelectProjectCost: selecttotalcost,
          newProjectName: projectName,
          reason: '',
          publishId: 0,
          serviceDeadID: 0,
          CountryID: 0,
          // CountryID: countryID,
          newProjectID: selectProjectID,
          // selectProjectID,
          // campaignId: sDProjectAPIData[0]?.campaignId,
          // selectProjectCost,
          applicantName: getepuserdata.fullName,
          applicantMobile: getepuserdata.mobile,
          EP_IDBase64URL,
          EPDeadCertificateBase64URL,
          EPApprovalLetterBase64URL,
          eP_ID,
          eP_DeadCertificate,
          eP_ApprovalLetter,
          projectTypeIdInt
        };
        setIsloading(true);
        const response = await postAsync(
          'ServiceDead/CreateSDAsync',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
              id: epUserID,
            },
          },
          'multipart/form-data',
        );
        setIsloading(false);
        if (response.statusCode === 200) {
          toast.success(t('Registration successful. Waiting for approval.'));
          navigate('/serviceForDeadList');
        } else if (response.statusCode === 422) {
          toast.warning(t('The project already register!'));
        } else {
          setIsloading(false);
          toast.error(t('Something went wrong, Please try again!'));
        }
      } catch (error) {
        setIsloading(false);
        toast.error(t('Something went wrong, Please try again!'));
      }
    }
  };

  const getEP_IDBase64 = (eP_ID) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(eP_ID);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log('Called', reader);

        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleEP_ID = (eP_ID) => {
    const inputEP_IDFileExtension = eP_ID.target.files[0]?.name?.split('.').pop();
    const selectedFile = eP_ID.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEP_IDFileExtension == 'jpg' ||
        inputEP_IDFileExtension == 'png' ||
        inputEP_IDFileExtension == 'jpeg' ||
        inputEP_IDFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEP_IDcheck(inputEP_IDFileExtension);
      let selectedPhoto = eP_ID.target.files[0];
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = (resolve) => {
          setInputEP_IDFileSize(fileSize);
          setEP_ID(resolve.result);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEP_IDFileExtension) && inputEP_IDFileSize < 2097152) {
        getEP_IDBase64(selectedPhoto)
          .then((result) => {
            let fileName = selectedPhoto?.name?.substring(0, 100);
            setinputEP_IDFile(fileName);
            setEP_IDBase64URL(result);
            setEP_ID(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_IDInputRef.current.value = '';
      setEP_IDBase64URL('');
      setEP_ID('');
      setInputEP_IDFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const getDeadCertificateBase64 = (deadCertificate) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(deadCertificate);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleDeadCertificate = (deadCertificate) => {
    const inputEP_IDFileExtension = deadCertificate.target.files[0]?.name?.split('.').pop();
    const selectedFile = deadCertificate.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEP_IDFileExtension == 'jpg' ||
        inputEP_IDFileExtension == 'png' ||
        inputEP_IDFileExtension == 'jpeg' ||
        inputEP_IDFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEP_DeadCertificatecheck(inputEP_IDFileExtension);
      let selectedPhoto = deadCertificate.target.files[0];
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = (resolve) => {
          setInputDeadCertificateFileSize(fileSize);
          setEP_DeadCertificate(resolve.result);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEP_IDFileExtension) && inputEP_IDFileSize < 2097152) {
        getDeadCertificateBase64(selectedPhoto)
          .then((result) => {
            let fileName = selectedPhoto?.name?.substring(0, 100);
            setInputDeadCertificate(fileName);
            setEPDeadCertificateBase64URL(result);
            setEP_DeadCertificate(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_DeadCertificateInputRef.current.value = '';
      setEPDeadCertificateBase64URL('');
      setEP_DeadCertificate('');
      setInputDeadCertificateFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const getApprovalLetterBase64 = (approvalLetter) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(approvalLetter);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleApprovalLetter = (approvalLetter) => {
    const inputEP_IDFileExtension = approvalLetter.target.files[0]?.name?.split('.').pop();
    const selectedFile = approvalLetter.target.files[0];
    const fileSize = selectedFile.size;
    if (
      (inputEP_IDFileExtension == 'jpg' ||
        inputEP_IDFileExtension == 'png' ||
        inputEP_IDFileExtension == 'jpeg' ||
        inputEP_IDFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setEP_ApprovalLettercheck(inputEP_IDFileExtension);
      let selectedPhoto = approvalLetter.target.files[0];
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = (resolve) => {
          setInputEP_ApprovalLetterFileSize(fileSize);
          setEP_ApprovalLetter(resolve.result);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      if (allowedFileExtensions.includes(inputEP_IDFileExtension) && inputEP_IDFileSize < 2097152) {
        getApprovalLetterBase64(selectedPhoto)
          .then((result) => {
            let fileName = selectedPhoto?.name?.substring(0, 100);
            setInputApprovalLetter(fileName);
            // selectedPhoto = result;
            setEPApprovalLetterBase64URL(result);
            setEP_ApprovalLetter(selectedPhoto);
            toast.success(t('File uploaded successfully.'));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      EP_ApprovalLetterInputRef.current.value = '';
      setEPApprovalLetterBase64URL('');
      setEP_ApprovalLetter('');
      setInputEP_ApprovalLetterFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const openModalDonor = (e) => {
    e.preventDefault();
    if (ep_IDCheck != 'pdf') {
      setGridModalOpenDonor(true);
    } else {
      setIsOpen(true);
    }
  };
  const openModalDead = (e) => {
    e.preventDefault();
    if (deadCertificateCheck != 'pdf') {
      setGridModalOpenDead(true);
    } else {
      setIsOpen(true);
    }
  };
  const openModalAppLetter = (e) => {
    e.preventDefault();
    if (approvalLetterCheck != 'pdf') {
      setGridModalOpenAppLetter(true);
    } else {
      setIsOpen(true);
    }
  };
  const closeModal = (e) => {
    e.preventDefault();

    setGridModalOpenDonor(false);
    setGridModalOpenDead(false);
    setGridModalOpenAppLetter(false);
  };

  const handleEP_IdDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_DeadCertificateDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_ApprovalLetterDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleEP_IdDelete = async (e) => {
    e.preventDefault();
    setEP_ID(null);
    setInputEP_IDFileSize('');
    // setinputEP_IDFile(null);
    EP_IDInputRef.current.value = '';
  };

  const handleEP_DeadCertificateDelete = async (e) => {
    e.preventDefault();
    setEP_DeadCertificate(null);
    setInputDeadCertificate(null);
    setInputDeadCertificateFileSize('');
    EP_DeadCertificateInputRef.current.value = '';
  };

  const handleEP_ApprovalLetterDelete = async (e) => {
    e.preventDefault();
    setEP_ApprovalLetter(null);
    setInputApprovalLetter(null);
    setInputEP_ApprovalLetterFileSize('');
    EP_ApprovalLetterInputRef.current.value = '';
  };

  const getrelativeIDData = async () => {
    await getAsync('Utilities/GetRelationsListAsync')
      .then((response) => {
        const result = response?.data;
        setRelationAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const handleProjectSelection = (e, projectName, projectid, totalCost, projectTypeId,projectTypeIdInt) => {
    e.preventDefault();
    const buttons = document.querySelectorAll('.selectbutton');
    buttons.forEach((button) => {
      if (button === e.target) {
        button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');
        const formSection = document.getElementById('form-section');
        if (formSection) {
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      } else {
        button.textContent = t('Select');
      }
    });
    setProjectName(projectName);
    setSelectProjectID(projectid);
    setSelecttotalcost(totalCost);
    setSelectProjectType(projectTypeId);
    setProjectTypeIdInt(projectTypeIdInt)
  };

  const bodySearch = {
    ProjectTypeID: selectProjectType,
    CountryID: countryID,
    selectProjectCostFrom: selectProjectCostFrom,
    selectProjectCostTo: selectProjectCostTo,
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    //  console.log('response?.statusCode');
    if (validateSearch()) {
      setIsLoading(true);
      setDatanotfound(false);
      const api = `APIClient/ProjectAllSHJC?countryId=${bodySearch?.CountryID}&projectTypeId=${bodySearch.ProjectTypeID}&isPartial=true&isFixed=true&fromCost=${bodySearch.selectProjectCostTo}&toCost=${bodySearch.selectProjectCostFrom}&sortByDate=DESC`;
      await getAsync(api)
        .then((response) => {
          setIsLoading(false);
          const result = response?.data;
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
          setSDProjectAPIData(result);
        })
        .catch((err) => {
          toast.error(t('No project found for the requested filters.'));
        });
    }
  };

  return (
    <div className="pt-12">
      <Userbanner />
      {isloading ? (
        <LoadingAnimation imageStyling={''} styling={'flex items-center py-5 align-middle justify-center space-x-2'} />
      ) : (
        <div className="w-auto  py-5 lg:py-10 ">
          <form>
            <div className="card">
              <div className="card-header">
                <h1 className="text-2xl text-center font-bold text-customgreen">{t('Service For Dead')}</h1>
              </div>
              <div className="card-body">
                <Accordion className="md:px-4">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Search Filters')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>{t('Project Type')}</label>
                          <select
                            value={selectProjectType}
                            onChange={(e) => setSelectProjectType(e.target.value)}
                            className=" w-full my-2 border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                          >
                            <option value="">--{t('All')}--</option>
                            {apiData?.map((item, index) => (
                              <option key={index + 1} value={item?.id}>
                                {isActive ? item?.name : item.name_EN}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>{t('Country')}</label>
                          <select
                            value={countryID}
                            onChange={(e) => setCountryID(e.target.value)}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                          >
                            <option
                              value="00000000-0000-0000-0000-000000000000
"
                            >
                              --{t('All')}--
                            </option>
                            {countryAPIData && countryAPIData.length > 0 ? (
                              countryAPIData?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {isActive ? item?.name_AR : item?.name_EN}
                                </option>
                              ))
                            ) : (
                              <option>{t('No country found')}</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>{t('Project Cost From')}</label>
                          <input
                            onInput={(event) => {
                              const { value } = event.target;
                              const regex = /^(\d+?)?$/;

                              if (regex.test(value) || value === '') {
                                setSelectProjectCostFrom(value);
                              } else {
                                event.target.value = value.slice(0, -1); // Revert to last valid value
                              }
                            }}
                            type="text"
                            placeholder={t('Cost From')}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>{t('Project Cost To')}</label>
                          <input
                            onInput={(event) => {
                              const { value } = event.target;
                              const regex = /^(\d+?)?$/;

                              if (regex.test(value) || value === '') {
                                setSelectProjectCostTo(value);
                              } else {
                                event.target.value = value.slice(0, -1); // Revert to last valid value
                              }
                            }}
                            type="text"
                            placeholder={t('Cost To')}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                          />
                        </div>
                      </div>
                      <br />
                      <br />
                      <div className="col-lg-6   flex justify-center sm:justify-start">
                        <div className="form-group ">
                          <button
                            className=" text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center my-2 me-1"
                            onClick={(e) => handleSearch(e)}
                          >
                            {t('Search')}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      {!isLoading ? (
                        <div className="col-lg-12">
                          <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">{`${sDProjectAPIData?.length > 0 ? t('Projects') : ''}`}</h1>

                          {/* <div
                            className={`projectCard ${sDProjectAPIData?.length > 0 ? 'h-[310px]' : 'h-0'}  min-w-[150px] max-w-full  overflow-y-auto flex justify-center items-center`}
                          >
                            {sDProjectAPIData?.map((data, index) => (
                              <Row data-aos="zoom-in" data-aos-once="true" key={data?.projectID}>
                                <Col className="mr-4">
                                  <div className="flex justify-center items-center">
                                    <Card
                                      style={{
                                        width: '260px',
                                        height: '300px',
                                        cursor: 'pointer',
                                      }}
                                      className={`${selectedCard === index ? 'scale-105  transition-transform duration-300 bg-green-50 shadow-2xl' : 'shadow-md'}  p-3 mb-2 sm:w-[200px] rounded-3xl`}
                                    >
                                      <Card.Title className="capitalize text-customgreen text-center">
                                        {data?.templateName.length > 15
                                          ? `${data?.templateName.slice(0, 15)}...`
                                          : data?.templateName}
                                      </Card.Title>
                                      {data?.file_Stream ? (
                                        <Card.Img
                                          variant="top"
                                          className="w-full h-32 rounded-t-3xl"
                                          src={`data:image/jpeg;base64,${data?.file_Stream}`}
                                        />
                                      ) : (
                                        <>
                                          <Card.Img
                                            className="img"
                                            variant="top"
                                            src={`data:image/jpeg;base64,${defaultImage}`}
                                          />
                                        </>
                                      )}
                                      <Card.Body className="flex justify-center items-center align-middle  gap-2">
                                        <Card.Text className=" text-sm font-bold tracking-tight text-gray-900">
                                          {t('Total Cost')}:
                                        </Card.Text>
                                        <Card.Text
                                          className={`ml-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}
                                        >
                                          {data?.totalCost} {t('AED')}
                                        </Card.Text>
                                      </Card.Body>
                                      <div className="flex justify-center ">
                                        <Button
                                          className="text-white selectbutton bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-8 py-2.5 text-center"
                                          onClick={(e) => {
                                            handleProjectSelection(
                                              e,
                                              data?.templateName,
                                              data?.id,
                                              data?.totalCost,
                                              data.projectTypeId,
                                            );
                                            setSelectedCard(index);
                                          }}
                                        >
                                          {t('Select')}
                                        </Button>
                                      </div>
                                    </Card>
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div> */}

                          <div
                            className={`projectCard ${sDProjectAPIData?.length > 0 ? 'h-[310px]' : 'h-0'} min-w-[150px] max-w-full`}
                          >
                            <div
                              className={`flex ${sDProjectAPIData?.length > 4 ? 'overflow-x-auto pb-2' : 'flex-wrap justify-center'} gap-4`}
                              style={{
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#888 transparent',
                              }}
                            >
                              {sDProjectAPIData?.map((data, index) => (
                                <div
                                  data-aos="zoom-in"
                                  data-aos-once="true"
                                  key={data?.projectID}
                                  className={`${sDProjectAPIData?.length > 4 ? 'flex-shrink-0' : 'w-[260px]'}`}
                                >
                                  <Card
                                    style={{
                                      width: '260px',
                                      height: '300px',
                                      cursor: 'pointer',
                                    }}
                                    className={`${selectedCard === index ? 'scale-105 transition-transform duration-300 bg-green-50 shadow-2xl' : 'shadow-md'} p-3 mb-2 rounded-3xl`}
                                  >
                                    <Card.Title className="capitalize text-customgreen text-center">
                                      {data?.templateName.length > 15
                                        ? `${data?.templateName.slice(0, 15)}...`
                                        : data?.templateName}
                                    </Card.Title>
                                    {data?.file_Stream ? (
                                      <Card.Img
                                        variant="top"
                                        className="w-full h-32 rounded-t-3xl"
                                        src={`data:image/jpeg;base64,${data?.file_Stream}`}
                                      />
                                    ) : (
                                      <Card.Img
                                        className="img"
                                        variant="top"
                                        src={`data:image/jpeg;base64,${defaultImage}`}
                                      />
                                    )}
                                    <Card.Body className="flex justify-center items-center align-middle gap-2">
                                      <Card.Text className="text-sm font-bold tracking-tight text-gray-900">
                                        {t('Total Cost')}:
                                      </Card.Text>
                                      <Card.Text
                                        className={`ml-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}
                                      >
                                        {data?.totalCost} {t('AED')}
                                      </Card.Text>
                                    </Card.Body>
                                    <div className="flex justify-center">
                                      <Button
                                        className="text-white selectbutton bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-8 py-2.5 text-center"
                                        onClick={(e) => {
                                          handleProjectSelection(
                                            e,
                                            data?.templateName,
                                            data?.id,
                                            data?.totalCost,
                                            data.projectTypeId,
                                            data?.projectTypeIdInt
                                          );
                                          setSelectedCard(index);
                                        }}
                                      >
                                        {t('Select')}
                                      </Button>
                                    </div>
                                  </Card>
                                </div>
                              ))}
                            </div>
                          </div>

                          {datanotfound && <DataNotFound />}
                        </div>
                      ) : (
                        <LoadingAnimation
                          imageStyling={''}
                          styling={'flex items-center py-5 align-middle justify-center space-x-2'}
                        />
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
                <br />

                <Accordion className="px-3">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Details')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography></Typography>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Name of Dead Person')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            value={deadName}
                            onChange={(e) => setDeadName(e.target.value)}
                            type="text"
                            placeholder={t('Name of Dead Person')}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                            minLength="1"
                            maxLength="50"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Project')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            value={projectName}
                            type="text"
                            placeholder={t('Project Name')}
                            className=" w-full border border-gray-300 cursor-not-allowed text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                            disabled
                            minLength="1"
                            maxLength="100"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Applicant Name')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            value={getepuserdata.fullName}
                            disabled
                            type="text"
                            placeholder="Applicant Name"
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                            minLength="1"
                            maxLength="100"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Applicant Mobile')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            value={getepuserdata.mobile}
                            placeholder="Applicant Mobile"
                            disabled
                            type="text"
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                            minLength="1"
                            maxLength="20"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            {t('Relationship')}
                            <span className="errmsg">*</span>
                          </label>
                          <select
                            value={relativeID}
                            onChange={(e) => setRelativeID(e.target.value)}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                          >
                            <option value="">--{t('SELECT')}--</option>
                            {relationAPIData?.map((item, index) => (
                              <option key={index + 1} value={item.relationID}>
                                {t(`${item.en_US}`)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <br />

                <Accordion className="px-3">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <h2 className="text-gray-800 font-bold text-pretty text-md">{t('Documents Upload')}</h2>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>
                            {t('Donor ID')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleEP_ID}
                            type="file"
                            className=" w-full my-2 border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                            ref={EP_IDInputRef}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 overflow-x-auto">
                        <br />
                        {allowedFileExtensions.includes(ep_IDCheck) &&
                          inputEP_IDFileSize <= 2097152 &&
                          inputEP_IDFileSize != '' && (
                            <Table className="text-sm text-left overflow-x-auto rtl:text-right ">
                              <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase ">
                                <Table.Row>
                                  <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('File')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row>
                                  <Table.HeaderCell className="text-black">1</Table.HeaderCell>
                                  <Table.HeaderCell className="text-black">
                                    <label
                                    // style={{
                                    //   color: 'red',
                                    //   fontWeight: '500',
                                    // }}
                                    >
                                      {/* {t(
                                      'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs',
                                    )}
                                    {inputEP_IDFileSize} -- {ep_IDCheck} */}
                                      {inputEP_IDFile}
                                    </label>
                                  </Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      onClick={(e) => handleEP_IdDownload(e, eP_ID)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </button>{' '}
                                    {/* Modal Create */}
                                    <>
                                      <button
                                        className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                        onClick={(e) => openModalDonor(e, eP_ID)}
                                        style={{
                                          margin: '5px',
                                        }}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </button>

                                      {ep_IDCheck != 'pdf' ? (
                                        // <MDBModal
                                        //   tabIndex="-1"
                                        //   show={gridModalOpenDonor}
                                        //   setShow={setGridModalOpenDonor}
                                        // >
                                        //   <MDBModalDialog>
                                        //     <MDBModalContent>
                                        //       <MDBModalHeader>
                                        //         <MDBModalTitle className="text-customgreen">
                                        //           {t('Donor ID')}
                                        //         </MDBModalTitle>
                                        //         <MDBBtn
                                        //           type="button"
                                        //           className="btn-close"
                                        //           color="none"
                                        //           onClick={(e) => closeModalDonor(e)}
                                        //         ></MDBBtn>
                                        //       </MDBModalHeader>
                                        //       <MDBModalBody>
                                        //         <div className="container-fluid bd-example-row">
                                        //           {EP_IDBase64URL && (
                                        //             <img
                                        //               style={{
                                        //                 height: '250px',
                                        //                 width: '450px',
                                        //               }}
                                        //               src={EP_IDBase64URL}
                                        //               alt="img.jpg"
                                        //             />
                                        //           )}
                                        //         </div>
                                        //       </MDBModalBody>
                                        //       <MDBModalFooter>
                                        //         <MDBBtn
                                        //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                        //           onClick={closeModalDonor}
                                        //         >
                                        //           {t('close')}
                                        //         </MDBBtn>
                                        //       </MDBModalFooter>
                                        //     </MDBModalContent>
                                        //   </MDBModalDialog>
                                        // </MDBModal>
                                        <ImageViewModal
                                          showModal={gridModalOpenDonor}
                                          setShowModal={setGridModalOpenDonor}
                                          closeModal={closeModal}
                                          title={'Donor ID'}
                                          renderLink={EP_IDBase64URL}
                                        />
                                      ) : (
                                        isOpen && (
                                          <PdfViewerModal
                                            pdfBase64={EP_IDBase64URL}
                                            toggleModal={toggleModal}
                                            visible={true}
                                          />
                                        )
                                      )}
                                    </>
                                    {/* end */}
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      style={{
                                        margin: '5px',
                                      }}
                                      onClick={(e) => handleEP_IdDelete(e)}
                                    >
                                      <DeleteOutlinedIcon />
                                    </button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          )}
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="my-2 px-2">
                            {t('Dead Certificate')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleDeadCertificate}
                            type="file"
                            ref={EP_DeadCertificateInputRef}
                            className=" w-full my-2 border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 overflow-x-auto">
                        <br />
                        {allowedFileExtensions.includes(deadCertificateCheck) &&
                          inputDeadCertificateFileSize <= 2097152 &&
                          inputDeadCertificateFileSize != '' && (
                            <Table className="text-sm text-left rtl:text-right ">
                              <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase ">
                                <Table.Row>
                                  <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('File')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row>
                                  <Table.HeaderCell className="text-black">1</Table.HeaderCell>
                                  <Table.HeaderCell className="text-black">
                                    <label
                                    // style={{
                                    //   color: 'red',
                                    //   fontWeight: '500',
                                    // }}
                                    >
                                      {/* {t(
                                      'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs',
                                    )}
                                    .{inputDeadCertificateFileSize} -- {deadCertificateCheck} */}
                                      {inputDeadCertificate}
                                    </label>
                                  </Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      onClick={(e) => handleEP_DeadCertificateDownload(e, eP_DeadCertificate)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </button>{' '}
                                    {/* Modal Create */}
                                    <>
                                      <button
                                        className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                        onClick={(e) => openModalDead(e, eP_DeadCertificate)}
                                        style={{
                                          margin: '5px',
                                        }}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </button>

                                      {deadCertificateCheck != 'pdf' ? (
                                        // <MDBModal tabIndex="-1" show={gridModalOpenDead} setShow={setGridModalOpenDead}>
                                        //   <MDBModalDialog>
                                        //     <MDBModalContent>
                                        //       <MDBModalHeader>
                                        //         <MDBModalTitle className="text-customgreen">
                                        //           {t('Dead Certificate')}
                                        //         </MDBModalTitle>
                                        //         <MDBBtn
                                        //           type="button"
                                        //           className="btn-close"
                                        //           color="none"
                                        //           onClick={(e) => closeModalDead(e)}
                                        //         ></MDBBtn>
                                        //       </MDBModalHeader>
                                        //       <MDBModalBody>
                                        //         <div className="container-fluid bd-example-row">
                                        //           {EPDeadCertificateBase64URL && (
                                        //             <img
                                        //               style={{
                                        //                 height: '250px',
                                        //                 width: '450px',
                                        //               }}
                                        //               src={EPDeadCertificateBase64URL}
                                        //               alt="img.jpg"
                                        //             />
                                        //           )}
                                        //         </div>
                                        //       </MDBModalBody>
                                        //       <MDBModalFooter>
                                        //         <MDBBtn
                                        //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                        //           onClick={closeModalDead}
                                        //         >
                                        //           {t('close')}
                                        //         </MDBBtn>
                                        //       </MDBModalFooter>
                                        //     </MDBModalContent>
                                        //   </MDBModalDialog>
                                        // </MDBModal>
                                        <ImageViewModal
                                          showModal={gridModalOpenDead}
                                          setShowModal={setGridModalOpenDead}
                                          closeModal={closeModal}
                                          title={'Dead Certificate'}
                                          renderLink={EPDeadCertificateBase64URL}
                                        />
                                      ) : (
                                        isOpen && (
                                          <PdfViewerModal
                                            pdfBase64={EPDeadCertificateBase64URL}
                                            toggleModal={toggleModal}
                                            visible={true}
                                          />
                                        )
                                      )}
                                    </>
                                    {/* end */}
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      style={{
                                        margin: '5px',
                                      }}
                                      onClick={(e) => handleEP_DeadCertificateDelete(e)}
                                    >
                                      <DeleteOutlinedIcon />
                                    </button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12 ">
                        <div className="form-group">
                          <label className="my-2 px-2">
                            {t('Approval Letter')}
                            <span className="errmsg">*</span>
                          </label>
                          <input
                            accept=".png, .jpeg, .jpg, .pdf"
                            onChange={handleApprovalLetter}
                            type="file"
                            className=" w-full my-2 border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                            ref={EP_ApprovalLetterInputRef}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 overflow-x-auto">
                        <br />
                        {allowedFileExtensions.includes(approvalLetterCheck) &&
                          inputEP_ApprovalLetterFileSize <= 2097152 &&
                          inputEP_ApprovalLetterFileSize != '' && (
                            <Table className="text-sm text-left rtl:text-right ">
                              <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase ">
                                <Table.Row>
                                  <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('File')}</Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row>
                                  <Table.HeaderCell className="text-black">1</Table.HeaderCell>
                                  <Table.HeaderCell className="text-black">
                                    <label
                                    // style={{
                                    //   color: 'red',
                                    //   fontWeight: '500',
                                    // }}
                                    >
                                      {/* {t(
                                    'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs',
                                  )}
                                  {inputEP_ApprovalLetterFileSize} -- {approvalLetterCheck} */}
                                      {inputApprovalLetter}
                                    </label>
                                  </Table.HeaderCell>
                                  <Table.HeaderCell className="text-white">
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      onClick={(e) => handleEP_ApprovalLetterDownload(e, eP_ApprovalLetter)}
                                      style={{
                                        margin: '5px',
                                      }}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </button>{' '}
                                    {/* Modal Create */}
                                    <>
                                      <MDBBtn
                                        className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                        onClick={(e) => openModalAppLetter(e, eP_ApprovalLetter)}
                                        style={{
                                          margin: '5px',
                                        }}
                                      >
                                        <VisibilityOutlinedIcon />
                                      </MDBBtn>

                                      {approvalLetterCheck != 'pdf' ? (
                                        // <MDBModal
                                        //   tabIndex="-1"
                                        //   show={gridModalOpenAppLetter}
                                        //   setShow={setGridModalOpenAppLetter}
                                        // >
                                        //   <MDBModalDialog>
                                        //     <MDBModalContent>
                                        //       <MDBModalHeader>
                                        //         <MDBModalTitle className="text-customgreen">
                                        //           {t('Approval Letter')}
                                        //         </MDBModalTitle>
                                        //         <MDBBtn
                                        //           type="button"
                                        //           className="btn-close"
                                        //           color="none"
                                        //           onClick={(e) => closeModalAppLetter(e)}
                                        //         ></MDBBtn>
                                        //       </MDBModalHeader>
                                        //       <MDBModalBody>
                                        //         <div className="container-fluid bd-example-row">
                                        //           {EPApprovalLetterBase64URL && (
                                        //             <img
                                        //               style={{
                                        //                 height: '250px',
                                        //                 width: '450px',
                                        //               }}
                                        //               src={EPApprovalLetterBase64URL}
                                        //               alt="img.jpg"
                                        //             />
                                        //           )}
                                        //         </div>
                                        //       </MDBModalBody>
                                        //       <MDBModalFooter>
                                        //         <MDBBtn
                                        //           className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                                        //           onClick={closeModalAppLetter}
                                        //         >
                                        //           {t('close')}
                                        //         </MDBBtn>
                                        //       </MDBModalFooter>
                                        //     </MDBModalContent>
                                        //   </MDBModalDialog>
                                        // </MDBModal>
                                        <ImageViewModal
                                          showModal={gridModalOpenAppLetter}
                                          setShowModal={setGridModalOpenAppLetter}
                                          closeModal={closeModal}
                                          title={'Approval Letter'}
                                          renderLink={EPApprovalLetterBase64URL}
                                        />
                                      ) : (
                                        isOpen && (
                                          <PdfViewerModal
                                            pdfBase64={EPApprovalLetterBase64URL}
                                            toggleModal={toggleModal}
                                            visible={true}
                                          />
                                        )
                                      )}
                                    </>
                                    {/* end */}
                                    <button
                                      className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                      style={{
                                        margin: '5px',
                                      }}
                                      onClick={(e) => handleEP_ApprovalLetterDelete(e)}
                                    >
                                      <DeleteOutlinedIcon />
                                    </button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          )}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>

              <div className="card-footer flex gap-2 flex-row items-center justify-center ">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                >
                  {t('Register')}
                </button>

                <Link
                  to={'/ServiceForDeadList'}
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                >
                  {t('Back')}
                </Link>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CreateServiceForDead;
